import { DialogFactory } from './DialogContext';
import { IntlShape } from 'react-intl';
import { DialogOptions } from './Dialog';
import { FormattedMessage, formatTranslation } from 'intl';
import { CommonTranslationKeys, DialogTranslationKeys } from 'intl/keys';


export const createDeleteDocumentDialog = (
  createDialog: DialogFactory,
  intl: IntlShape,
  documentTitle: string
): Promise<void> => {
  return createDialog({
    title: formatTranslation(intl, DialogTranslationKeys.confirmationDeleteDocumentTitle),
    description: (
      <span>
        <FormattedMessage
          id={DialogTranslationKeys.confirmationDeleteDocumentWeb}
          values={{
            documentName: (
              <span key={documentTitle} style={{ color: 'crimson' }}>
                {documentTitle}
              </span>
            ),
          }}
        />
      </span>
    ),
    customControllerLabels: [
      formatTranslation(intl, CommonTranslationKeys.cancel),
      formatTranslation(intl, CommonTranslationKeys.remove),
    ],
  });
};

export const createUnlinkDocumentationDialog = (
  createDialog: DialogFactory,
  intl: IntlShape,
  documentTitle: string
): Promise<void> => {
  return createDialog({
    title: formatTranslation(intl, DialogTranslationKeys.confirmationUnlinkDocumentationTitle),
    description: (
      <span>
        <FormattedMessage
          id={DialogTranslationKeys.confirmationUnlinkDocumentationWeb}
          values={{
            documentName: (
              <span key={documentTitle} style={{ fontWeight: 'bold' }}>
                {documentTitle}
              </span>
            ),
          }}
        />
      </span>
    ),
    customControllerLabels: [
      formatTranslation(intl, CommonTranslationKeys.cancel),
      formatTranslation(intl, CommonTranslationKeys.unlink),
    ],
  });
};

export function rotateFileDialog(): DialogOptions {
  return {
    catchOnCancel: false,
    title: (
      <FormattedMessage id={DialogTranslationKeys.confirmationRotateDocumentationTitle} />
    ),
    description: (
      <span>
        <FormattedMessage id={DialogTranslationKeys.confirmationRotateDocumentation} />
      </span>
    ),
  };
}
